import api from "../../apis";

export const googleLogin = async () => {
  try {
    const response = await api.post("/oauth/google/generate", {});
    return response.data.link;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const googleOAuthAPI = async (state, code, scope) => {
  try {
    const response = await api.get(`/oauth/google?state=${state}&code=${code}&scope=${scope}`);
    return response;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};